import { Box, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";

export const Pill = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  height: "22px",
  padding: "1px 8px",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: 400,
  lineHeight: "20px",
  whiteSpace: "nowrap",
  backgroundColor: ediphiPalette.mainBackground,
  color: ediphiPalette.black950,
}));
